import $dom from 'cash-dom';
import sha256 from 'js-sha256';

const init = () => {
  checkForBypass();
  checkForReset();
  bindToFormSubmit();
};

// Helper method to simplify setting auth cart attribute
const setAuthParam = value => {
  const data = {
    attributes: {
      auth: value
    }
  };

  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });
};

// Main code to handle form input and validation
const bindToFormSubmit = () => {
  $dom($dom('.password-form')[0]).on('submit', function(e) {
    e.preventDefault();

    if (isValidPassword(e.target.elements['password'].value)) {
      setAuthParam('valid').then(data => {
        console.log('Success:', data);
        location.reload();
      });
    } else {
      const errorField = $dom($dom('.password-form-input-error-message')[0]);
      errorField.attr('style', 'visibility: visible');
    }
  });
};

// Checks if the password is provided via a URL param, and logs in the user if it is present and valid
const checkForBypass = () => {
  const params = new URLSearchParams(window.location.search);
  if (isValidPassword(params.get('pw'))) {
    // Delete `pw` param from url, so that it doesn't persist in user's browser
    params.delete('pw');
    window.history.replaceState(
      {},
      document.title,
      `${window.location.pathname}?${params.toString()}`
    );

    // Set auth param and reload, to trigger login
    setAuthParam('valid')
      .then(() => {
        location.reload();
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
};

// Helper method for testing, to force clear the auth param and reset back to login page
const checkForReset = () => {
  if (new URLSearchParams(window.location.search).get('auth') === 'reset') {
    setAuthParam(null)
      .then(data => {
        console.log('Success:', data);
        location.href = '/';
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
};

// Helper method for checking if the password is valid based on the hash stored in window.PxlApp.auth
const isValidPassword = password => {
  if (password === null) {
    return false;
  } else {
    const hashedPassword = sha256.hmac(
      '69967b8de8fce057c5cdfd6e0e4535095b663d1b170e095c6e4e68b4e7374086',
      password
    );
    const validPassword = window.PxlApp.auth;
    return hashedPassword === validPassword;
  }
};

export default init;
